import React, { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  disabled,
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-medium rounded-full transition-colors focus:outline-none focus-visible:ring-2";

  const variantClasses = {
    primary: "bg-primary text-white hover:bg-primary-hover focus-visible:ring-primary",
    secondary:
      "bg-sa-surface-hover text-sa-text hover:bg-sa-border focus-visible:ring-sa-border-hover",
    outline:
      "border border-sa-border text-sa-text hover:border-sa-border-hover hover:bg-sa-surface-hover focus-visible:ring-sa-border-hover",
    ghost: "text-sa-text hover:bg-sa-surface-hover focus-visible:ring-sa-border-hover",
  };

  const sizeClasses = {
    sm: "text-sm px-2.5 py-1.5",
    md: "text-sm px-4 py-2",
    lg: "text-base px-6 py-3",
  };

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : "";

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`;

  return (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export default Button;
